import { useState } from 'react';
import { CountdownList } from '../features/countdown/CountdownList.js';
import { TaskStats } from '../features/stats/TaskStats.js';
import { HabitList } from '../features/habits/HabitList.js';
import { ListsPanel } from '../features/lists/ListsPanel.js';
import { TagsPanel } from '../features/tags/TagsPanel.js';
import { SettingsPanel } from '../features/settings/SettingsPanel.js';
import { TrashList } from '../features/trash/TrashList.js';
import { AuditList } from '../features/audit/AuditList.js';

type Aba =
  | 'habitos'
  | 'resumo'
  | 'contagem'
  | 'listas'
  | 'tags'
  | 'lixeira'
  | 'ajustes'
  | 'auditoria';

const ABAS: Array<{ id: Aba; label: string }> = [
  { id: 'habitos', label: 'Hábitos' },
  { id: 'resumo', label: 'Resumo' },
  { id: 'contagem', label: 'Contagem' },
  { id: 'listas', label: 'Listas' },
  { id: 'tags', label: 'Tags' },
  { id: 'lixeira', label: 'Lixeira' },
  { id: 'ajustes', label: 'Ajustes' },
  // Por ultimo: e consulta rara, de "o que aconteceu com isso?", nao de uso diario.
  { id: 'auditoria', label: 'Auditoria' },
];

/**
 * Aba "Mais" (spec 8 e 9.5).
 *
 * Habitos e contagem regressiva dividem a tela porque a spec 8 fecha a
 * navegacao em cinco abas, e as duas sao, do ponto de vista do uso, a mesma
 * pergunta em escalas diferentes: o que eu repito, e o que esta chegando.
 *
 * A fase 9 acrescentou lixeira e ajustes. As quatro cabem aqui pelo mesmo
 * motivo: nenhuma e frequente o bastante para gastar uma das cinco abas da
 * spec 8, e todas sao "o resto do app".
 */
export function More() {
  const [aba, setAba] = useState<Aba>('habitos');

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4 p-4">
      {/*
        `flex-wrap` nos dois niveis, e nao um `overflow-x-auto` na tira.

        Sao SEIS secoes, e a tira media 503 px numa tela de 397 — o titulo mais
        as abas passavam de 560 px. Conteudo mais largo que a viewport faz o
        Android alargar o layout viewport para caber o mais largo, e a pagina
        INTEIRA passa a abrir numa escala menor: e o "abre com zoom errado e eu
        ajusto na pinca" que o uso real relatou. Nao era zoom; era estouro.

        Quebrar em duas linhas mantem as seis alcancaveis sem gesto nenhum. Uma
        tira rolavel esconderia "Lixeira" atras de um arrasto lateral que nada
        na tela anuncia — e a lixeira e justamente para onde se corre quando
        algo sumiu.
      */}
      <header className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="font-display text-lg font-semibold">Mais</h1>

        <div className="flex flex-wrap gap-1" role="tablist" aria-label="Seções">
          {ABAS.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={item.id === aba}
              onClick={() => setAba(item.id)}
              className={[
                'min-h-touch rounded-sm px-3 text-sm transition-colors duration-150',
                item.id === aba
                  ? 'bg-brand-blue-soft font-medium text-brand-blue'
                  : 'text-text-mut hover:bg-surface-2',
              ].join(' ')}
            >
              {item.label}
            </button>
          ))}
        </div>
      </header>

      {/*
        Estatisticas de TAREFA. As de foco vivem na aba Foco, junto do timer que
        as produz — separa-las de la significaria olhar duas telas para
        responder "como foi a semana".
      */}
      {aba === 'resumo' ? <TaskStats /> : null}
      {aba === 'habitos' ? <HabitList /> : null}
      {aba === 'contagem' ? <CountdownList /> : null}
      {/*
        Listas aparecem aqui E na barra lateral. A barra some abaixo de 768px,
        entao sem esta aba o celular nao teria acesso nenhum a elas.
      */}
      {aba === 'listas' ? <ListsPanel /> : null}
      {/* Mesmo motivo das listas: a barra lateral some abaixo de 768px. */}
      {aba === 'tags' ? <TagsPanel /> : null}
      {aba === 'lixeira' ? <TrashList /> : null}
      {aba === 'ajustes' ? <SettingsPanel /> : null}
      {aba === 'auditoria' ? <AuditList /> : null}
    </div>
  );
}
